import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  FORMAT_ELEMENT_COMMAND,
  INDENT_CONTENT_COMMAND,
  OUTDENT_CONTENT_COMMAND,
} from 'lexical';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import JustifyIcon from 'assets/images/icons/justify.svg?react';
import TextCenterIcon from 'assets/images/icons/text-center.svg?react';
import TextIndentLeftIcon from 'assets/images/icons/text-indent-left.svg?react';
import TextIndentRightIcon from 'assets/images/icons/text-indent-right.svg?react';
import TextLeftIcon from 'assets/images/icons/text-left.svg?react';
import TextRightIcon from 'assets/images/icons/text-right.svg?react';
import { RichTextEditorToolbarPluginProps } from 'components/editor/RichTextEditor.types';

interface TextAlignmentButtonsProps {
  disabled: boolean;
  toolbarSettings: RichTextEditorToolbarPluginProps['toolbarSettings'];
}

const TextAlignmentButtons = ({
  disabled,
  toolbarSettings: { features },
}: TextAlignmentButtonsProps) => {
  const { t } = useTranslation();
  const [editor] = useLexicalComposerContext();

  if (!features?.textAlignment) {
    return null;
  }

  return (
    <Dropdown disabled={disabled} id="rich-text-editor-text-alignment">
      <Dropdown.Toggle
        className="toolbar-item toolbar-item--large toolbar-item--horizontal-dropdown"
        data-testid="toolbar-button-textAlignment"
      >
        <TextLeftIcon />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <MenuItem
          aria-label={t('form.editor.buttons.alignLeft')}
          eventKey="1"
          onClick={() => {
            editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'left');
          }}
        >
          <TextLeftIcon />
        </MenuItem>
        <MenuItem
          aria-label={t('form.editor.buttons.alignCenter')}
          eventKey="2"
          onClick={() => {
            editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'center');
          }}
        >
          <TextCenterIcon />
        </MenuItem>
        <MenuItem
          aria-label={t('form.editor.buttons.alignRight')}
          eventKey="3"
          onClick={() => {
            editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'right');
          }}
        >
          <TextRightIcon />
        </MenuItem>
        <MenuItem
          aria-label={t('form.editor.buttons.alignJustify')}
          eventKey="4"
          onClick={() => {
            editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'justify');
          }}
        >
          <JustifyIcon />
        </MenuItem>
        <MenuItem
          aria-label={t('form.editor.buttons.indentLeft')}
          eventKey="5"
          onClick={() => {
            editor.dispatchCommand(INDENT_CONTENT_COMMAND, undefined);
          }}
        >
          <TextIndentLeftIcon />
        </MenuItem>
        <MenuItem
          aria-label={t('form.editor.buttons.outdentLeft')}
          eventKey="6"
          onClick={() => {
            editor.dispatchCommand(OUTDENT_CONTENT_COMMAND, undefined);
          }}
        >
          <TextIndentRightIcon />
        </MenuItem>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default TextAlignmentButtons;
